import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSuperadminAuth } from '../contexts/SuperadminAuthContext';
// import { superadminAuthService } from '../services/superadminAuthService'; // Temporarily disabled
import { SUPERADMIN_ROUTES } from './routes';

interface SuperadminProtectedRouteProps {
  children: React.ReactNode;
}

export const SuperadminProtectedRoute: React.FC<SuperadminProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading, logout } = useSuperadminAuth();
  const location = useLocation();

  // Check cookie on every navigation (temporarily disabled until cookie issue is resolved)
  useEffect(() => {
    const checkAuthCookie = () => {
      // Temporarily disable cookie check since server is not setting the cookie properly
      // TODO: Re-enable once server cookie issue is fixed
      console.log('Cookie check disabled temporarily - server not setting auth cookie');
      
      // if (isAuthenticated && !superadminAuthService.hasAuthCookie()) {
      //   console.warn('Auth cookie missing, logging out user');
      //   logout();
      // }
    };

    // Add a small delay to allow cookie to be set after login
    const timeoutId = setTimeout(checkAuthCookie, 100);

    // Set up interval to check periodically (every 30 seconds)
    const interval = setInterval(checkAuthCookie, 30000);

    // Also check on focus (when user returns to tab)
    const handleFocus = () => checkAuthCookie();
    window.addEventListener('focus', handleFocus);

    return () => {
      clearTimeout(timeoutId);
      clearInterval(interval);
      window.removeEventListener('focus', handleFocus);
    };
  }, [isAuthenticated, logout]);

  // Show nothing while checking auth
  if (loading) {
    return null;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to={SUPERADMIN_ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

